import React from "react"
import styled from "styled-components"
import { StaticImage } from "gatsby-plugin-image"

const Family = () => {

  return (
    <StyledGallery>
      <div>
        <figure>
          <div>
            <StaticImage
            src="../../../images/mabani/cande-wife-kids.jpg"
            alt=""
            />
          </div>
          <figcaption>Candé&rsquo;s wife, Hava, and their children, at the family’s home in Guinea-Bissau.</figcaption>
        </figure>
        <figure>
          <div>
            <StaticImage
            src="../../../images/mabani/cande-parents.jpg"
            alt=""
            />
          </div>
          <figcaption>Candé’s parents hold a family photo at their home.</figcaption>
        </figure>
      </div>
    </StyledGallery>
  )
}
export default Family;
export { Family }

const StyledGallery = styled.div`
  position: relative;
  padding: 0;
  width: 100vw;
  left: 50%;
  margin-left: -50vw;
  > div {
    position: relative;
    margin: 0 auto;
    max-width: 80em;
  }
  figure {
    margin: calc(2 * var(--text-size)) 0;
  }
  figcaption {
    font-size: var(--text-size-large);
    font-family: var(--font-serif);
    line-height: 1.4;
    margin: 0.5em 0;
    text-align: center;
  }

  @media ( min-width: 48em ) {
    padding: 0 calc(2 * var(--text-size));
    figure {
      display: grid;
      grid-template: 1fr / 1.5fr 1fr;
      grid-gap: var(--gutter);
      align-items: center;
      margin: calc(3 * var(--text-size)) 0;
      max-width: 70em;
      &:not(:first-of-type) {
        margin-top: calc(4 * var(--text-size));
      }
      &:nth-of-type(odd) {
        margin-left: 10%;
      }
      &:nth-of-type(even) {
        grid-template: 1fr / 1fr 1.5fr;
        margin-right: 10%;
        > figcaption {
          grid-row: 1;
          grid-column: 1;
          text-align: right;
        }
      }
    }
    figcaption {
      font-size: calc(1.5 * var(--text-size));
      text-align: left;
      margin: 1.5em 0 0;
    }
  }
`